import { useState, useRef, useEffect } from 'react'
import { createModel } from 'hox'
import { useMap } from 'ahooks';
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { settleService } from '../../settleService'
import { OrderTotalResult } from '../../settleTypes'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'

export const totalModel = createModel(function () {

    //列表数据源
    const [dataSource, setDataSource] = useState<OrderTotalResult[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [selectedData, setSelectedData] = useState<OrderTotalResult[]>([]);
    //表单数据
    const [formInfo, { set: setFormInfo, get: getFormInfo }] = useMap<string, any>([]);
    //弹窗可见
    const [mode, setMode] = useState<string>("add") //add、edit
    const [visible, setVisible] = useState<boolean>(false)
    //账单详情
    const [franchiseeCode, setFranchiseeCode] = useState<string | undefined>(undefined)
    const [selected, setSelected] = useState<any>(null);

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    //列表数据
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: any = searchParam) => {
        setLoading(true)
        const searchParams = {
            searchItem: {
                ...searchValue,
            },
            pageSize: page?.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{ column: 'createTime', rule: 'DESC' }],
        }
        let { retData } = await settleService.total(searchParams)
        const { list, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(list)
        setLoading(false)
    }

    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    //获取一条详情数据 Api
    const getOne = async (mode: string, id: string) => {
        let { retData } = await settleService.one(id)
        const { ...formVal } = retData
        retData && setFormInfo(mode, { ...formVal });
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedData,
        pgCfg,
        visible,
        mode,
        formInfo,
        loading,
        franchiseeCode,
        selected,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        setSelectedData,
        resetSearchParam,
        updateSearchParam,
        loadData,
        getOne,
        setVisible,
        setMode,
        setFormInfo,
        getFormInfo,
        setFranchiseeCode,
        setSelected,
    }
})
